// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"143":"app","736":"vendor"}[chunkId] || chunkId) + "." + {"125":"0101156f","143":"8c5b220b","736":"22598132","741":"3043cf6e"}[chunkId] + ".css";
};